"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAST_Function = void 0;
const isAST_Function = (node) => {
    return (typeof (node === null || node === void 0 ? void 0 : node.type) === 'string' &&
        Array.isArray(node === null || node === void 0 ? void 0 : node.args));
};
exports.isAST_Function = isAST_Function;
